import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState
} from "react";
// import { tokens } from "../../../../../theme";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import TextInput from "../../../../../components/theme/inputs/TextInput";
import SettingGroup from "../../../../../components/theme/settings/SettingGroup";
import Subheading from "../../../../../components/theme/text/Subheading";
import Text from "../../../../../components/theme/text/Text";
import { useEditRelationMutation, useGetRelationQuery } from "../../../../../newapi/global/relation/relationSlice";
import { selectUser, selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { tokens } from "../../../../../theme";
import { showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { UserPrivileges } from "../../../../../utils/permissions";

const GridActions = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    props.hasRelationCompanyInfoPermission &&
      <ButtonGroup version={2}>
          <Shbutton
              isLoading={props.isLoading}
              className={"group-btn"}
              onClick={props.action}
              color={theme.palette.mode === "dark" ? "blue" : "primary"}
              variant="contained"
              endIcon={<SaveIcon />}
          >
              {t('save')}
          </Shbutton>
      </ButtonGroup>
  )
};

let gridOptions = {
  export:true,
  disableCustomActionsOnPhone: true,
  isSidepanel: true,
};

const Personal = ({ settings = [], ...props }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
    

  const hasRelationCompanyInfoPermission = useSelector((state) => 
      selectUserPermission(state, [UserPrivileges.RP_COMPANY_INFO_READ, UserPrivileges.RP_COMPANY_INFO_MANAGE])
  );

  const relation_id = useSelector((state) => state.settings.environment.selectedId);

  
  const { data: incData, error, isLoading } = useGetRelationQuery(
    relation_id, {
      skip: !relation_id
  });

 useEffect(() => {
  setRelationData(incData);
}, [incData]);
 const [relationData, setRelationData] = useState();

 const handleChange = (key, value) => {
  setRelationData({
    ...relationData,
    [key]: value
  });
};

 const [updateRelation, {isLoading: editLoading}] = useEditRelationMutation()

 
 const SaveSettings = async () => {
    if(editLoading) return;
    const response = await updateRelation(relationData);
    showToastMessageUpdateRequest(t,response.data)
 };


 useEffect(() => {
  props.replaceView({
      ...props.config,
      gridOptions:gridOptions,
      mobileActions:<GridActions hasRelationCompanyInfoPermission={hasRelationCompanyInfoPermission} action={SaveSettings} isLoading={editLoading}/>
  });

  return () => {
      // console.log("unmounting warehouse");
  }
},[relationData,hasRelationCompanyInfoPermission,SaveSettings,editLoading]);

  return  (
    <Box
      sx={{
        pt:4,
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 3,
          overflow: "hidden",
          // background:
          //   theme.palette.mode === "dark"
          //     ? colors.grey[300]
          //     : colors.bg["tertiary"],
          paddingX: 4,
          // paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
            
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            // background:"purple",
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            display:"flex",
            justifyContent: "space-between",
            "@media screen and (max-width: 47.9375em)": {
              display: "none",
            },
          }}
        >
          <Subheading>{t("relation_business_title")}</Subheading>
          {hasRelationCompanyInfoPermission &&
            <ButtonGroup version={2}>
              <Shbutton editLoading={editLoading} className={"group-btn"} color={"blue"} variant="contained" onClick={SaveSettings}>{t("save")}</Shbutton>
            </ButtonGroup>
          }
        </Box>
      
        <Box
          sx={{
            background:
              theme.palette.mode === "dark"
                ? colors.grey[300]
                : colors.bg["tertiary"],
            flex: 1,
            display: "flex",
            justifyContent: "flex-start",
            alignItems:"flex-start",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            borderBottomLeftRadius: 16,
            borderBottomightRadius: 16,
            gap: 2,
            padding: 2,
            "@media screen and (max-width: 1023px)": {
              display:"block",

            overflow:'auto',
            pb:8,
            },
            "@media screen and (max-width: 767px)": {

              pt:0,
              px:0.5,
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],

            }
          }}
        >
          <Box
            sx={{
              background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
              flex:1,
              borderRadius:4,
              padding:3,
              "@media screen and (max-width: 1023px)" : {
                p:1.5,
                py:3,
              },
              "@media screen and (max-width: 767px)" : {
                px:0,
              }
            }}
          >
            <SettingGroup title={t("contact")}>
              <Box
                sx={{
                  mt:1.5,
                  display:"flex",
                  flexDirection:"column",
                  gap:2,
                  "@media screen and (max-width: 1023px)" : {
                    my:2,
                    mx:1,
                  }
                }}
              >
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                    opacity: 0.6,
                  }}
                >
                  <Text light sx={{ opacity: 1.0 }}>{t('name')}</Text>
                  <TextInput
                    value={relationData?.name}
                    disabled
                    sx={{  }}
                    // onChange={(e) => handleChange("name", e.target.value)}
                  />
                </Box>

                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t('phone')}</Text>
                  <TextInput
                    value={relationData?.phone}
                    onChange={(e) => handleChange("phone", e.target.value)}
                  />
                </Box>

                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t('email')}</Text>
                  <TextInput
                    value={relationData?.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                </Box>
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t('website')}</Text>
                  <TextInput
                    value={relationData?.website}
                    onChange={(e) => handleChange("website", e.target.value)}
                  />
                </Box>
              </Box>
            </SettingGroup>
          </Box>
          <Box
            sx={{
              background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
              flex:1,
              borderRadius:4,
              padding:3,
              "@media screen and (max-width: 1023px)" : {
                p:1.5,
                py:3,
                mt:2,
              },
              "@media screen and (max-width: 767px)" : {
                mt:0,
                pt:0,
              },
              "@media screen and (max-width: 767px)" : {
                px:0,
                pt:0,
              }

            }}
          >
            <SettingGroup title={t("address_details")}>
              <Box
                sx={{
                  mt:1.5,
                  display:"flex",
                  flexDirection:"column",
                  gap:2,
                  "@media screen and (max-width: 1023px)" : {
                    my:2,
                    mx:1,
                  }
                }}
              >
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("street")}</Text>
                  <TextInput
                    value={relationData?.street}
                    onChange={(e) => handleChange("street", e.target.value)}
                  />
                </Box>
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("house_number")}</Text>
                  <TextInput
                    value={relationData?.house_nr}
                    onChange={(e) => handleChange("house_nr", e.target.value)}
                  />
                </Box>
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("house_number_addition")}</Text>
                  <TextInput
                    value={relationData?.house_nr_extra}
                    onChange={(e) => handleChange("house_nr_extra", e.target.value)}
                  />
                </Box>
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("postal_code")}</Text>
                  <TextInput
                    value={relationData?.postal}
                    onChange={(e) => handleChange("postal", e.target.value)}
                  />
                </Box>
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("city")}</Text>
                  <TextInput
                    value={relationData?.city}
                    onChange={(e) => handleChange("city", e.target.value)}
                  />
                </Box>
              </Box>
            </SettingGroup>
          </Box>
          <Box
            sx={{
              background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
              flex:1,
              borderRadius:4,
              padding:3,
              "@media screen and (max-width: 1023px)" : {
                p:1.5,
                py:3,
                mt:2,
              },
              "@media screen and (max-width: 767px)" : {
                mt:0,
                pt:0,
              },
              "@media screen and (max-width: 767px)" : {
                px:0,
                pt:0,
              }

            }}
          >
            <SettingGroup title={t("export_settings")}>
              <Box
                sx={{
                  mt:1.5,
                  display:"flex",
                  flexDirection:"column",
                  gap:2,
                  "@media screen and (max-width: 1023px)" : {
                    my:2,
                    mx:1,
                  }
                }}
              >
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("kvk")}</Text>
                  <TextInput
                    value={relationData?.kvk}
                    onChange={(e) => handleChange("kvk", e.target.value)}
                  />
                </Box>
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("vat_number")}</Text>
                  <TextInput
                    value={relationData?.vatNumber}
                    onChange={(e) => handleChange("vatNumber", e.target.value)}
                  />
                </Box>
                <Box className={"setting-group"}
                  sx={{
                    display:"flex",
                    alignItems:'center',
                    justifyContent:"space-between",
                    width:1,
                  }}
                >
                  <Text light>{t("eori_number")}</Text>
                  <TextInput
                    value={relationData?.eoriNumber}
                    onChange={(e) => handleChange("eoriNumber", e.target.value)}
                  />
                </Box>

              </Box>
            </SettingGroup>
          </Box>
          {/* in group */}
        </Box>
        
      </Box>
    </Box>
  );
};

export default Personal;
